import React from 'react';

import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useActions } from '../../../shared/common/hooks/useActions';
import { useTypedSelector } from '../../../shared/common/hooks/useTypedSelector';

export const ToggleChart = () => {
    const { isChartVisible } = useTypedSelector((state)=>state.chart);
    const { setChartVisible } = useActions();

    const btnText = isChartVisible ? 'Скрыть график' : 'Показать график';
    const handleToggle = (e: React.MouseEvent<HTMLElement>) => {
        e.currentTarget.blur();
        localStorage.setItem('isChartVisible',`${!isChartVisible}`);
        setChartVisible();
    };
    if(window.location.pathname === '/dashboards'){
        return null;
    }
    return(
        <Button 
            className="report-action-btn"
            onClick={handleToggle} 
            icon={isChartVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        >
            {btnText}
        </Button>
    );
};
